import { render, staticRenderFns } from "./trans_other.vue?vue&type=template&id=60f11323"
import script from "./trans_other.vue?vue&type=script&lang=js"
export * from "./trans_other.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports